export default class  ValoresClienteAdministrativoModel {
    [key: string]: number | boolean | undefined;

    valorTotalAdicional?: number;
    valorHoraParada?: number;
    valorPatins?: number;
    valorHoraTrabalhada?: number;
    valorPedagio?: number;
    valorPrestador?: number;
    valorGuinchoPesado?: number;
    valorOperadora?: number;
    valorComissaoCorretor?: number;
    valorAgravo?: number;
    valorDesconto?: number;
    idCliente?: number;
	frota?: boolean;
    preco?: number;
    valorSaida?: number;
    valorExcedente?: number;
    qtdKmExcedente?: number;
    checkboxValorSaida?: boolean;
    qtdPatins?: number;
    qtdHoraTrabalhada?: number;
    qtdHoraParada?: number;
    kmTotal?: number;
}